'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconWindowRestore, iconWindowRestoreTag } from '@ni/nimble-components/dist/esm/icons/window-restore';
import { wrap } from '../../utilities/react-wrapper';

export type { IconWindowRestore };
export { iconWindowRestoreTag };
export const NimbleIconWindowRestore = wrap(IconWindowRestore);